export enum HoursActions {
  Reset = "reset",
  FetchHours = "fetchHours",
  FetchHour = "fetchHour",
  AddHour = "addHour",
  ApproveHours = "approveHours",
  EditHour = "editHour",
}
